<script>
  // import { fade, fly } from "svelte/transition";

  export let text = "";
  export let placeholder;
  export let margin;
  export let error;
  export let textarea;
  // error = 1;
  $: {
    if (text) error = false;
  }
</script>

<div class="textbox">
  {#if textarea}
    <textarea {placeholder} bind:value={text} />
    <div class="textarea-border" />
  {:else}
    <input type="text" {placeholder} bind:value={text} />
    <div class="border" />
  {/if}

  <div
    class="asterisk-wrapper"
    style={text ? "display:none;" : `position:absolute; left: ${margin}px; `}
  >
    {#if margin}
      <span>*</span>
    {/if}
  </div>
  {#if error}
    {#if placeholder == "Email"}
      <span class="error">Please enter a valid e-mail address</span>
    {:else if placeholder == "Website Link" || placeholder == "Social Network Link"}
      <span class="error">Please enter a valid link</span>
    {/if}
  {/if}
  <!-- {#if text}
    <div class="right-text-wrapper" in:fly={{ x: 100, duration: 500 }}>
      <div class="right-text-body">
        <span class="input-text" in:fade out:fade
          >{side ? side : placeholder}</span
        >
        {#if margin}
          <span
            style="position:relative; top:-4px; right: 5px; "
            in:fade
            out:fade>*</span
          >
        {/if}
      </div>
    </div>
  {/if} -->
</div>

<style>
  .asterisk-wrapper {
    position: absolute;
    z-index: 2;
    top: -4px;
  }
  .asterisk-wrapper > span {
    color: #757575;
  }
  .textbox {
    position: relative;
    background: black;
    z-index: 1;
    height: 60px;
    overflow: hidden;
    width: 100%;
  }
  input {
    color: white;
    width: calc(100% + 1px);
    font-size: 16px;
    outline: none;
    border: none;
    background: black;
    z-index: 2;
    padding: 0 0 0 0;
    margin: 0;
    position: relative;
    top: 0px;
    border-radius: 0;
  }
  textarea {
    color: white;
    width: calc(100% + 1px);
    font-size: 16px;
    outline: none;
    border: none;
    background: black;
    z-index: 2;
    padding: 0 0 0 0;
    margin: 0;
    position: relative;
    top: 0px;
    border-radius: 0;
    resize: none;
    height: 55px;
    /* overflow: hidden; */
    /* height: 100%; */
  }
  .border {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 0%;
    height: 30px;
    background: white;
    z-index: -1;
    transition: 0.35s ease-out;
    background: linear-gradient(180deg, black 29px, white 1px);
  }
  input:focus ~ .border {
    width: 100%;
  }
  .textarea-border {
    position: absolute;
    content: "";
    top: 30px;
    left: 0;
    width: 0%;
    height: 30px;
    background: white;
    z-index: -1;
    transition: 0.35s ease-out;
    background: linear-gradient(180deg, black 29px, white 1px);
    /* margin-top: 15px; */
  }
  textarea:focus ~ .textarea-border {
    width: 100%;
  }
  .error {
    color: #d02b2b;
    position: absolute;
    top: 35px;
    font-weight: 600;
    font-size: 11px;
  }
</style>
